import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Sparkles, Clock, Gift } from "lucide-react";

// Tasteful Founding Creator banner — only for creators on an active Founding trial.
// Never shown to paid / lifetime / complimentary Pro users.
export function FoundingCreatorBanner() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/creator/trial-status").then((r) => setS(r.data)).catch(() => setS(null)); }, []);
  if (!s || !s.is_founding_trial) return null;

  const days = s.days_remaining;
  const expiry = s.trial_expiry ? new Date(s.trial_expiry).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" }) : null;
  const soon = days !== null && days <= 14;

  return (
    <div data-testid="founding-creator-banner"
      className="relative mt-6 overflow-hidden rounded-3xl border border-emerald-300 bg-gradient-to-br from-emerald-600 via-emerald-500 to-teal-500 p-5 text-white shadow-sm sm:p-6">
      <Sparkles className="pointer-events-none absolute -right-3 -top-3 h-24 w-24 text-white/10" />
      <div className="relative flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white/20 backdrop-blur"><Gift className="h-6 w-6" /></div>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <h3 className="font-display text-lg font-bold sm:text-xl">You're a Founding Creator!</h3>
            <span className="inline-flex items-center gap-1 rounded-full bg-white/20 px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide"><Sparkles className="h-3 w-3" /> Nearfluence Pro</span>
          </div>
          <p className="mt-1 text-sm text-white/90">Enjoy 3 months of Nearfluence Pro, on us — Media Kit, application attachments, discovery boost, analytics and growth tips all unlocked.</p>
          <div className="mt-3 flex flex-wrap items-center gap-2 text-xs">
            {days !== null && (
              <span data-testid="founding-days-left" className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 font-semibold ${soon ? "bg-white text-amber-700" : "bg-white/20 text-white"}`}>
                <Clock className="h-3.5 w-3.5" /> {days} day{days === 1 ? "" : "s"} left{expiry ? ` · until ${expiry}` : ""}
              </span>
            )}
            <span className="rounded-full bg-white/15 px-2.5 py-1">No card required · no automatic charge at the end</span>
          </div>
          {soon && <p className="mt-2 text-xs text-white/90">Your free Pro period is ending soon. Paid plans aren't live yet — we'll let you know your options before anything changes.</p>}
        </div>
      </div>
    </div>
  );
}
